import { useState, useMemo } from 'react';

export const useHojaPesadorFilters = (hojas) => {
  const [busquedaBoleta, setBusquedaBoleta] = useState('');
  const [filtrosAvanzados, setFiltrosAvanzados] = useState({
    fechaDesde: '',
    fechaHasta: '',
    conductorId: '',
    vehiculoId: '',
    division: '',
    inspector: '',
  });
  const [mostrarFiltros, setMostrarFiltros] = useState(false);
  const [ordenamiento, setOrdenamiento] = useState('desc');

  // Obtener divisiones únicas
  const divisionesUnicas = useMemo(() => {
    return [...new Set(hojas.map(h => h.division))].filter(Boolean).sort();
  }, [hojas]);

  // Obtener inspectores únicos
  const inspectoresUnicos = useMemo(() => {
    const inspectores = hojas
      .map(h => h.inspector_2)
      .filter(Boolean);
    return [...new Set(inspectores)].sort();
  }, [hojas]);

  // Filtrar y ordenar hojas
  const hojasFiltradas = useMemo(() => {
    let resultado = hojas.filter((hoja) => {
      // Filtro de búsqueda por boleta (número de tiquete)
      const matchBoleta = busquedaBoleta === '' || 
        hoja.numero_tiquete?.toLowerCase().includes(busquedaBoleta.toLowerCase());

      // Filtro de fecha desde
      const matchFechaDesde = !filtrosAvanzados.fechaDesde || 
        new Date(hoja.fecha_entrega) >= new Date(filtrosAvanzados.fechaDesde);

      // Filtro de fecha hasta
      const matchFechaHasta = !filtrosAvanzados.fechaHasta || 
        new Date(hoja.fecha_entrega) <= new Date(filtrosAvanzados.fechaHasta);

      // Filtro de conductor
      const matchConductor = !filtrosAvanzados.conductorId || 
        hoja.conductor_id === filtrosAvanzados.conductorId;

      // Filtro de vehículo
      const matchVehiculo = !filtrosAvanzados.vehiculoId || 
        hoja.vehiculo_id === filtrosAvanzados.vehiculoId;

      // Filtro de división
      const matchDivision = !filtrosAvanzados.division || 
        hoja.division === filtrosAvanzados.division;

      // Filtro de inspector
      const matchInspector = !filtrosAvanzados.inspector || 
        hoja.inspector_2 === filtrosAvanzados.inspector;

      return matchBoleta && matchFechaDesde && matchFechaHasta && 
             matchConductor && matchVehiculo && matchDivision && matchInspector;
    });

    // Ordenar por fecha de entrega
    resultado.sort((a, b) => {
      const fechaA = new Date(a.fecha_entrega);
      const fechaB = new Date(b.fecha_entrega);
      return ordenamiento === 'desc' ? fechaB - fechaA : fechaA - fechaB;
    });

    return resultado;
  }, [hojas, busquedaBoleta, filtrosAvanzados, ordenamiento]);

  const limpiarFiltros = () => {
    setBusquedaBoleta('');
    setFiltrosAvanzados({
      fechaDesde: '',
      fechaHasta: '',
      conductorId: '',
      vehiculoId: '',
      division: '',
      inspector: '',
    });
  };

  const toggleOrdenamiento = () => {
    setOrdenamiento(prev => prev === 'desc' ? 'asc' : 'desc');
  };

  const contarFiltrosActivos = () => {
    let count = busquedaBoleta ? 1 : 0;
    count += Object.values(filtrosAvanzados).filter(v => v !== '').length;
    return count;
  };

  return {
    busquedaBoleta,
    setBusquedaBoleta,
    filtrosAvanzados,
    setFiltrosAvanzados,
    mostrarFiltros,
    setMostrarFiltros,
    ordenamiento,
    setOrdenamiento,
    hojasFiltradas,
    divisionesUnicas,
    inspectoresUnicos,
    limpiarFiltros,
    toggleOrdenamiento,
    contarFiltrosActivos
  };
};
